<template>
	<div>
		<el-row>
			<el-form :inline="true" :model="searchForm" :ref="searchForm" style="margin: 0">
				<el-form-item label="副仓：">
					<el-select size="medium" v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择"
						style="width: 200px;">
						<el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME"
							:value="item.ID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" @click="search()">筛选</el-button>
				</el-form-item>
			</el-form>
		</el-row>
		<el-row>
			<el-button size="medium" @click="handleNew">新增</el-button>
		</el-row>
		<el-row style="margin-top:20px">
			<el-table :data="tableData" border stripe>
				<el-table-column prop="SCHEME_NAME" label="名称"></el-table-column>
				<el-table-column label="供应商" prop="GYS_NAME" min-width="100px"></el-table-column>
				<el-table-column prop="DEFAULT_POINT" label="缺省点数"></el-table-column>
				<el-table-column prop="BE_DEFAULT" label="是否缺省方案"></el-table-column>
				<el-table-column prop="action" label="操作" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
						<el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
						<el-button type="text" size="small" @click="specialProduct(scope.row)">特殊产品加点</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-row>
				<el-pagination @current-change="handleCurrentChange" :page-size="pageSize" layout="total, prev, pager, next"
					:total="totalNum" style="text-align:right">
				</el-pagination>
			</el-row>
		</el-row>
		<!-- 新增页面的弹窗 -->
		<el-dialog center :visible.sync="dialogVisible" width="500px" title="新增加点级别" :close-on-click-modal="false"
			:show-close="false">
			<el-form  ref="addForm" :rules="rule" :model="addForm" label-width="150px">
				<el-form-item label="副仓：" prop="SUB_WAREHOUSE">
					<el-select class="el-select-box" size="medium" v-model="addForm.SUB_WAREHOUSE" filterable placeholder="请选择" style="width:220px;height:40px;">
						<el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="加点方案名称：" prop="NAME">
					<el-input v-model="addForm.NAME" style="width:220px;"></el-input>
				</el-form-item>
				<el-form-item label="默认加点：" prop="SCHEME_POINT">
					<el-input class="SCHEME_POINT" style="width:220px;" v-model="addForm.SCHEME_POINT"><template
							slot="append">%</template></el-input>
				</el-form-item>
				<el-form-item label="是否为缺省方案：" prop="BE_DEFAULT">
					<el-checkbox v-model="addForm.BE_DEFAULT"></el-checkbox>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button @click="handleAdd()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      dialogVisible: false,
      pageSize: 10,
      tableData: [],
      companyID: '',
      totalNum: 0,
      searchForm: {
        SUB_WAREHOUSE: Number(sessionStorage.getItem('tcId')),
      },

      newTcList: [],
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      addForm: {
        SUB_WAREHOUSE: '',
        BE_DEFAULT: false,
      },
      rule: {
        SUB_WAREHOUSE: [{ required: true, message: '请输入副仓', trigger: 'blur' }],
        NAME: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],
        SCHEME_POINT: [{ required: true, message: '请输入加点级别', trigger: 'blur' }],
      },
    };
  },

  methods: {
    // 筛选
    search() {
      this.query(0);
    },
    query(index) {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX: index,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.SUB_WAREHOUSE) {
        params.GYS_ID = this.searchForm.SUB_WAREHOUSE;
      }
      http
        .post(params)
        .then((result) => {
          this.tableData = result.length > 0 ? result[0].SCHEME_LIST : [];
          this.totalNum = result.length > 0 ? result[0].TOTAL_COUNT : 0;
          this.tableData.forEach((item) => {
            item.BE_DEFAULT = item.BE_DEFAULT === 1 ? '是' : '否';
          });
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },

    handleDelete(row) {
      // console.log('row',row)
      this.$confirm('您确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10023',
          OTYPE: 10,
          SCHEME_ID: row.SCHEME_ID,
          GYS_ID: row.GYS_ID,
        };
        http
          .post(params)
          .then((result) => {
            this.query();
            this.$message.show({ text: '删除成功！', type: 'success' });
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      });
    },
    handleCurrentChange(index) {
      this.query(index - 1);
    },
    handleUpdate(row) {
      // console.log('row', row)
      this.$router.push({ name: 'updateAddPrice', params: { SCHEME_ID: row.SCHEME_ID, DEFAULT_POINT: row.DEFAULT_POINT, GYS_ID: row.GYS_ID } });
    },
    specialProduct(row) {
      // console.log(row);
      this.$router.push({ name: 'specialPrice', params: { SCHEME_ID: row.SCHEME_ID, DEFAULT_POINT: row.DEFAULT_POINT, GYS_ID: row.GYS_ID } });
    },
    handleNew() {
      this.dialogVisible = true;
    },
    handleAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10023',
            OTYPE: 6,
            GYS_ID: this.addForm.SUB_WAREHOUSE,
            SCHEME_NAME: this.addForm.NAME,
            DEFAULT_POINT: this.addForm.SCHEME_POINT,
            BE_DEFAULT: Number(this.addForm.BE_DEFAULT),
          };
          if (!this.addForm.SUB_WAREHOUSE || !this.addForm.NAME) {
            this.$message.show({ text: '请输入副仓和方案名称', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.addForm.SCHEME_POINT)) {
            this.$message.show({ text: '请输入正数加点', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(data).then((res) => {
            // console.log('res', res)
            // this.dialogVisible = false
            // this.SCHEME_ID = res[0].SCHEME_ID
            document.body.style.cursor = 'default';
            // this.$router.push({
            // 	path: `/newAddPrice/${res[0].SCHEME_ID}`,
            // 	query: { SCHEME_ID: res[0].SCHEME_ID,SCHEME_NAME:this.addForm.NAME,SCHEME_POINT:this.addForm.SCHEME_POINT}
            // })
            this.$router.push({
              name: 'newAddPrice',
              params: { SCHEME_ID: res[0].SCHEME_ID, SCHEME_NAME: this.addForm.NAME, SCHEME_POINT: this.addForm.SCHEME_POINT },
            });
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },

  },

  mounted() {
    // 这里用来在系统设置中设置页面展示条目，文件在systemSetting的unitManage中，由前端控制条目，存储于localStorage中，key为USER_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('USER_PAGE_COUNT')) ? Number(localStorage.getItem('USER_PAGE_COUNT')) : 10;
    this.query(0);
  },
};
</script>
<style scoped>
.el-select-box /deep/ .el-input__inner{
	height: 40px;
	line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/priceRules.vue